function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.528,
    height: 24.086,
    viewBox: "0 0 27.528 24.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heart",
    "data-name": "Icon awesome-heart",
    d: "M24.855,3.895a7.352,7.352,0,0,0-10.032.731L13.763,5.717,12.7,4.626A7.352,7.352,0,0,0,2.672,3.895,7.72,7.72,0,0,0,2.14,15.072l10.4,10.742a1.686,1.686,0,0,0,2.435,0l10.4-10.742a7.715,7.715,0,0,0-.527-11.177Z",
    transform: "translate(0.001 -2.248)",
    fill: "#fff",
    style: {
      mixBlendMode: "difference",
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b8e920ffa337e47bebf4451da4176c38.svg";
export { ForwardRef as ReactComponent };